"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAddressCreateDto = instanceOfAddressCreateDto;
exports.AddressCreateDtoFromJSON = AddressCreateDtoFromJSON;
exports.AddressCreateDtoFromJSONTyped = AddressCreateDtoFromJSONTyped;
exports.AddressCreateDtoToJSON = AddressCreateDtoToJSON;
exports.AddressCreateDtoToJSONTyped = AddressCreateDtoToJSONTyped;
const State_1 = require("./State");
/**
 * Check if a given object implements the AddressCreateDto interface.
 */
function instanceOfAddressCreateDto(value) {
    if (!('line1' in value) || value['line1'] === undefined)
        return false;
    if (!('city' in value) || value['city'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined)
        return false;
    if (!('zealWorkLocationId' in value) || value['zealWorkLocationId'] === undefined)
        return false;
    return true;
}
function AddressCreateDtoFromJSON(json) {
    return AddressCreateDtoFromJSONTyped(json, false);
}
function AddressCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'line1': json['line1'],
        'city': json['city'],
        'state': (0, State_1.StateFromJSON)(json['state']),
        'postalCode': json['postalCode'],
        'zealWorkLocationId': json['zealWorkLocationId'],
        'line2': json['line2'] == null ? undefined : json['line2'],
    };
}
function AddressCreateDtoToJSON(json) {
    return AddressCreateDtoToJSONTyped(json, false);
}
function AddressCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'line1': value['line1'],
        'city': value['city'],
        'state': (0, State_1.StateToJSON)(value['state']),
        'postalCode': value['postalCode'],
        'zealWorkLocationId': value['zealWorkLocationId'],
        'line2': value['line2'],
    };
}
//# sourceMappingURL=AddressCreateDto.js.map